import { DOC_HOST } from '../../../base/constants/cgi-base';
// 添加为我的模版
export var ADD_TO_MY_TEMPLATE = "".concat(DOC_HOST, "/cgi-bin/template/mytemplate_add");
// 模版详情
export var TEMPLATE_DETAIL = "".concat(DOC_HOST, "/cgi-bin/template/template_detail");
// 设置模板信息展示过的标志位
export var SET_TIP_FLAG = "".concat(DOC_HOST, "/ep/api/settipflag");
